import { useEffect,useState} from "react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";

import Button from '@mui/material/Button';

import SmashBuzzApi from "../api/api.js";

export default function TourneyChart() {
  const [tourneyData,setTourneyData] = useState(null);
  const [selectedTournament,setSelectedTournament] = useState(null);

  // get tournament data on mount
  useEffect( () => {
    SmashBuzzApi.getTournaments()
      .then( response => {
        //console.log("Fetched Tournament Data");
        setTourneyData(response);
      })
      .catch( error =>{
        console.log("Error- Could not get tournament data: "+error);
      })
  },[]);

  // on click, get selected tournament info and display below chart
  const handleClick = (event) =>{
    if(event && event.activeLabel){
      let tournamentName = event.activeLabel;
      tourneyData.forEach((item, i) => {
        if(item.name===tournamentName){
          setSelectedTournament(item);
        }
      });
    }
  }

  const tournamentButton = (tournament) => {
    return (<a target="_blank" rel="noopener noreferrer" href={selectedTournament.link}><Button variant="outlined" color="primary">
      {selectedTournament.name}</Button></a>);
  }

  return (
    <div>
      <ResponsiveContainer width="90%" height={400}>
        <LineChart
          width={500}
          height={300}
          data={tourneyData}
          margin='{{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5
          }}'          
          onClick={handleClick}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="entrants" name="Entrants" stroke="#111111" />
          <Line type="monotone" dataKey="count" name="Tweets" stroke="#82ca9d" />
        </LineChart>
      </ResponsiveContainer>
      <br/>
      { (selectedTournament!=null) ? tournamentButton(selectedTournament) : ("Select a tournment for link.")}
    </div>
  );
}
